import { MarkSpec } from 'prosemirror-model';

/**
 * Citation mark for inline references
 * 
 * Example: "This is established (Smith, 2020; Jones, 2021)"
 *                             └──────────┬─────────────┘
 *                                    citation mark
 */
export const citationMarkSpec: MarkSpec = {
  // Match comment mark EXACTLY - two simple attributes
  attrs: {
    citationId: { default: null },
    resolved: { default: false }
  },
  
  inclusive: false,
  excludes: '',
  
  parseDOM: [
    {
      tag: 'span[data-citation-id]',
      getAttrs: (dom: HTMLElement | string) => {
        if (typeof dom === 'string') return false;
        return {
          citationId: dom.getAttribute('data-citation-id'),
          resolved: dom.getAttribute('data-resolved') === 'true'
        };
      }
    }
  ],
  
  toDOM(mark) {
    console.log('[citationMark] toDOM called:', mark.attrs);
    return [
      'span',
      {
        'data-citation-id': mark.attrs.citationId,
        'data-resolved': mark.attrs.resolved,
        'class': 'library-citation',
        'title': 'Double-click to open PDF, or select and delete to remove citation'
      },
      0
    ];
  }
};

